export default {
  data: () => ({
    providerId: null
  }),
  methods: {
    selectProvider(provider) {
      this.providerId = provider.id
    } 
  }
}